var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"text-uppercase font-weight-bold",attrs:{"label":"","small":"","color":_vm.color,"text-color":"white"}},[_vm._v(_vm._s(_vm.count))])}
var staticRenderFns = []

export { render, staticRenderFns }